var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 32,
    viewBox: "0 0 86 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    y: 15.0078,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#FF6900"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 6,
    y: 12.0078,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#FF6900"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 12,
    y: 9.00781,
    width: 2,
    height: 14,
    rx: 1,
    fill: "#FF6900"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 18,
    y: 14.0078,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#FF6900"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 24,
    y: 8.00781,
    width: 2,
    height: 16,
    rx: 1,
    fill: "#FF6900"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 30,
    y: 9.00781,
    width: 2,
    height: 14,
    rx: 1,
    fill: "#FF6900"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 36,
    y: 11.0078,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#4F4F4F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 42,
    y: 11.0078,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#4F4F4F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 48,
    y: 11.0078,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#4F4F4F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 54,
    y: 9.00781,
    width: 2,
    height: 14,
    rx: 1,
    fill: "#4F4F4F"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 60,
    y: 11.0078,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#4F4F4F"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 66,
    y: 8.00781,
    width: 2,
    height: 16,
    rx: 1,
    fill: "#4F4F4F"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 72,
    y: 11.0078,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#4F4F4F"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 78,
    y: 14.0078,
    width: 2,
    height: 4,
    rx: 1,
    fill: "#4F4F4F"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.66,
    x: 84,
    y: 15.0078,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.989510802efee8901d073b7df9f68f2a.svg";
export { ForwardRef as ReactComponent };